if (!customElements.get('details-modal')) {
  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');

      this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

      const closeButtons = this.querySelectorAll('button[type="button"], .search-modal__close-button, .modal__close-button');
      closeButtons.forEach((button) => button.addEventListener('click', this.close.bind(this)));

      this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }

    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true) {
      if (!this.detailsContainer || !this.detailsContainer.hasAttribute('open')) return;
      if (this.detailsContainer.classList.contains('is-closing')) return;

      this.detailsContainer.classList.add('is-closing');
      removeTrapFocus(focusToggle ? this.summaryToggle : null);

      setTimeout(() => {
        this.detailsContainer.removeAttribute('open');
        this.detailsContainer.classList.remove('is-closing');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
      }, 280);
    }
  }

  customElements.define('details-modal', DetailsModal);
}
